// extracted by mini-css-extract-plugin
export const cards = "index-module--cards--2Hvfw";
export const codeStyles = "index-module--codeStyles--Swfh8";